export const ruEnLocale: Record<string, string> = {
  'Виза без отеля 3-4 дня однократный въезд-85': 'Visa without hotel 3-4 days single entry-85',
  'Виза без отеля 3-4 дня двойной въезд-95': 'Visa without hotel 3-4 days double entry-95',
  'Виза без отеля 3-4 дня многократный въезд-105': 'Visa without hotel 3-4 days multiple entry-105',
  'Виза с отелем 3-4 дня однократный въезд-60': 'Visa with hotel 3-4 days single entry-60',
  'Виза с отелем 3-4 дня двойной въезд-80': 'Visa with hotel 3-4 days double entry-80',
  'Виза с отелем 3-4 дня многократный въезд-100': 'Visa with hotel 3-4 days multiple entry-100',
  'Виза с отелем 3-4 дня однократный въезд с гарантией-95': 'Visa with hotel 3-4 days single entry with guarantee-95',
  'Виза с отелем 3-4 дня двойной въезд с гарантией-115': 'Visa with hotel 3-4 days double entry with guarantee-115',
  'Виза с отелем 3-4 дня многократный въезд с гарантией-135': 'Visa with hotel 3-4 days multiple entry with guarantee-135',
  'Виза с отелем 48 часов однократный въезд-85': 'Visa with hotel 48 hours single entry',
  'Виза с отелем 48 часов двойной въезд-100': 'Visa with hotel 48 hours double entry',
  'Виза с отелем 48 часов многократный въезд-120': 'Visa with hotel 48 hours multiple entry',
  'Виза с отелем 48 часов однократный въезд с гарантией-120': 'Visa with hotel 48 hours single entry with guarantee',
  'Виза с отелем 48 часов двойной въезд с гарантией-135': 'Visa with hotel 48 hours double entry with guarantee',
  'Виза с отелем 48 часов многократный въезд с гарантией-140': 'Visa with hotel 48 hours multiple entry with guarantee',
  'Виза с отелем 24 часа однократный въезд-105': 'Visa with hotel 24 hours single entry-105',
  'Виза с отелем 24 часа двойной въезд-125': 'Visa with hotel 24 hours double entry-125',
  'Виза с отелем 24 часа многократный въезд-145': 'Visa with hotel 24 hours multiple entry-145',
  'Виза с отелем 24 часа однократный въезд с гарантией-150': 'Visa with hotel 24 hours single entry with guarantee-150',
  'Виза с отелем 24 часа двойной въезд с гарантией-170': 'Visa with hotel 24 hours double entry with guarantee-170',
  'Виза с отелем 24 часа многократный въезд с гарантией-190': 'Visa with hotel 24 hours multiple entry with guarantee-190',
  'Виза с отелем 6 часов однократный въезд-200': 'Visa with hotel 6 hours single entry-200',
  'Виза с отелем 6 часов двойной въезд-220': 'Visa with hotel 6 hours double entry-220',
  'Виза с отелем 6 часов многократный въезд-240': 'Visa with hotel 6 hours multiple entry-240',
  'Виза с отелем 6 часов однократный въезд с гарантией-240': 'Visa with hotel 6 hours single entry with guarantee-240',
  'Виза с отелем 6 часов двойной въезд с гарантией-260': 'Visa with hotel 6 hours double entry with guarantee-260',
  'Виза с отелем 6 часов многократный въезд с гарантией-280': 'Visa with hotel 24 hours multiple entry with guarantee-280',

  'отложенная подача': 'delayed submission',
  'в обработке': 'processing',
  'ожидает оплаты': 'awaiting payment',
  'проверка оплаты': 'payment verification',
  'оплачено': 'paid',
  'одобрено': 'approved',
  'отказ': 'rejected',
  'плохое фото': 'bad photo',
  'заполняется': 'in progress',
  'в работе': 'at work',
  "Мужской": 'Male',
  'Женский': 'Female',
  "Россия": 'Russia',
  "Армения": 'Armenia',
  "Азербайджан": 'Azerbaijan',
  "Беларусь": 'Belarus',
  "Казахстан": 'Kazakhstan',
  "Туркменистан": 'Turkmenistan',
  "Грузия": 'Georgia',
  "Киргизстан": 'Kyrgyzstan',
  "Молдова": 'Moldova',
  "Таджикистан": 'Tajikistan',
  "Узбекистан": 'Uzbekistan',
  "Женат/замужем": 'Married',
  "Не гражданин Латвии": 'Non-citizen of Latvia',
  'Не гражданин Эстонии': 'Non-citizen of Estonia',
  "Не замужем/не женат": 'Not married',
  "Живу раздельно с супругой (-ом)": 'I live separately from my spouse',
  "Вдовец/вдова": 'Widower/widow',
  "Разведен(а)": 'Divorced',
  "Деловой партнер": 'Business partner',
  "Друг/подруга": 'Friend/girlfriend',
  "Коллега": 'Colleague',
  "Ребенок": 'Child',
  "Родитель": 'Parent',
  "Сестра/Брат": 'Sister/Brother',
  "Сожитель": 'Cohabitant',
  "Супруг/Супруга": 'Spouse',
  "Христианство": 'Christianity',
  "Мусульманство": 'Islam',
  "Буддизм": 'Buddhism',
  "Индуизм": 'Hinduism',
  "Ислам": 'Islam',
  "Сикхизм": 'Sikhism',
  "Даосизм": 'Taoism',
  "Неверующий": 'Atheist',
  "Другая": "Other",
  "Без образования": "No Education",
  "Начальная школа": "Elementary School",
  "Средняя школа": "High School",
  "Техникум": "College",
  "Высшее": "Higher Education",
  "Магистратура": "Master's Degree",
  "Безработный": 'Unemployed',
  "Бизнесмен": 'Businessman',
  "Домохозяйка": "Housewife",
  "Пенсионер": 'Retiree',
  "Ребёнок/Младенец": 'Child/Infant',
  "Сотрудник офиса": 'Office Worker',
  "Специалист": 'Specialist',
  "Студент/Ученик": 'Student/Pupil',
  "Да": 'Yes',
  "Нет": "No",
  'первый заявитель':'First Applicant'
}